import {
    formsGalleryUrl,
    loginUrl,
    signupIFrameSimpleUrl,
    signupUrl,
    usersManualPhoneVerificationUrl,
} from 'mk2/apps/users/urls';
import { Route } from 'mk2/containers/Application/Application';

export const routes: Route[] = [{
    app: 'users',
    exact: true,
    path: usersManualPhoneVerificationUrl,
    getPage: () => {
        return import('mk2/apps/users/containers/ManualPhoneVerification/ManualPhoneVerificationPage' /* webpackChunkName: "users.ManualPhoneVerification" */);
    },
    modules: [ 'mk2/apps/users/containers/ManualPhoneVerification/ManualPhoneVerificationPage' ],
}, {
    app: 'users',
    exact: true,
    path: signupIFrameSimpleUrl,
    getPage: () => {
        return import('mk2/apps/users/containers/SignupIFrame/SignupIFramePage' /* webpackChunkName: "users.SignupIFrame" */);
    },
    modules: [ 'mk2/apps/users/containers/SignupIFrame/SignupIFramePage' ],
}, {
    app: 'users',
    exact: true,
    path: signupUrl,
    getPage: () => {
        return import('mk2/apps/users/containers/Signup/SignupPage' /* webpackChunkName: "users.Signup" */);
    },
    modules: [ 'mk2/apps/users/containers/Signup/SignupPage' ],
}, {
    app: 'users',
    exact: true,
    path: loginUrl,
    getPage: () => {
        return import('mk2/apps/users/containers/Login/LoginPage' /* webpackChunkName: "users.Login" */);
    },
    modules: [ 'mk2/apps/users/containers/Login/LoginPage' ],
}, {
    app: 'users',
    exact: true,
    path: formsGalleryUrl,
    getPage: () => {
        return import('mk2/apps/users/containers/FormsGallery/FormsGalleryPage' /* webpackChunkName: "users.FormsGallery" */);
    },
    modules: [ 'mk2/apps/users/containers/FormsGallery/FormsGalleryPage' ],
}];
